<div class="our-journey" id="our-journey">
  <div class="container">
    <span class="badge-pill">{{ 'our_journey.badge' | translate }}</span>
    <h2 class="section-heading">{{ 'our_journey.heading' | translate }}</h2>
    <p class="section-subheading">{{ 'our_journey.subheading' | translate }}</p>

    <div class="timeline">
      <div class="timeline-line"></div>

      <owl-carousel-o [options]="carouselOptions" class="timeline-carousel d-none d-md-block">
        @for (milestone of milestones; track milestone; let i = $index) {
        <ng-template carouselSlide [id]="'milestone-' + i">
          <div class="timeline-item">
            <span class="timeline-dot"></span>
            <p class="timeline-year">{{ milestone.yearKey | translate }}</p>
            <p class="timeline-desc">{{ milestone.descKey | translate }}</p>
          </div>
        </ng-template>
        }
      </owl-carousel-o>

      <div class="timeline-mobile d-md-none">
        @for (milestone of milestones; track milestone) {
        <div class="timeline-item">
          <span class="timeline-dot"></span>
          <p class="timeline-year">{{ milestone.yearKey | translate }}</p>
          <p class="timeline-desc">{{ milestone.descKey | translate }}</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>